<template>
  <div>
    <SingleRideHeader
      :presentedText="t('rideChecklistAccommodations')"
     />
    <b-container class="py-5">
      <SingleRideChecklist />
    </b-container>
    <PageFooter />
  </div>
</template>

<script>

import PageFooter from '@/components/PageFooter.vue'
import SingleRideChecklist from '@/components/SingleRideChecklist'
import SingleRideHeader from '@/components/SingleRideHeader';

import { mapActions } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';

export default {
  name: 'RideChecklist',
  mixins: [translationMixin],
  components: {
    SingleRideChecklist,
    PageFooter,
    SingleRideHeader
  },
  methods: mapActions(['rideUpdateMarkerByScrollerLocation']),
  created(){
    window.addEventListener('scroll', this.rideUpdateMarkerByScrollerLocation);
    const rideIdFromUrl = this.$route.params.id;
    if ( rideIdFromUrl ){
      this.$store.commit('setLowedRideId', rideIdFromUrl);
    }

  },
  mounted(){
    this.$store.commit('rideSetPresentedDay', null);
    // this.rideUpdateMarkerByScrollerLocation();
  },
  destroyed(){
    window.removeEventListener('scroll', this.rideUpdateMarkerByScrollerLocation);
  },

};


</script>